

























































import { DataprocessDto } from '@/services/dataprocess';
import { Vue, Component, PropSync, Prop, Watch } from 'vue-property-decorator';
@Component
export default class DataprocessFlinksql1 extends Vue {
  @PropSync('formData') syncFormData!: DataprocessDto;
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  
}
